import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import AppHeader from "@/components/content/AppHeader/AppHeader.vue";
import AppFooter from "@/components/content/AppFooter/AppFooter.vue";
import { onMounted, ref } from "vue";
import { onBeforeMount } from "vue";
import Cookies from "js-cookie";
import { useRouter } from "vue-router";
export default {
  __name: 'App',
  setup(__props) {
    const router = useRouter();
    //appBody DOM
    const appBody = ref(null);
    let pc = ref(false);
    onBeforeMount(() => {});
    onBeforeMount(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    });
    onMounted(() => {
      if (document.documentElement.clientWidth > 750) {
        pc.value = true;
        // router.push("/homePage")
      } else {
        pc.value = false;
        // router.push("/homePageMobile")
      }
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_AppFooterMobile = _resolveComponent("AppFooterMobile");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: "appBody",
        ref_key: "appBody",
        ref: appBody,
        style: _normalizeStyle({
          marginBottom: !_unref(pc) ? '2rem' : '0'
        })
      }, [_unref(pc) ? (_openBlock(), _createBlock(AppHeader, {
        key: 0
      })) : _createCommentVNode("", true), _createVNode(_component_router_view), _unref(pc) ? (_openBlock(), _createBlock(AppFooter, {
        key: 1
      })) : _createCommentVNode("", true)], 4), !_unref(pc) ? (_openBlock(), _createBlock(_component_AppFooterMobile, {
        key: 0
      })) : _createCommentVNode("", true)], 64);
    };
  }
};